export default __webpack_public_path__ + "static/media/Search.e5a25404.svg";